import { useUserDisplayName } from '~/components/Dialogs/hooks/useUserDisplayName';
import Spinner from '~/components/icons/Spinner';

type Props = {
    delegateId: string | undefined;
};

export const DelegateName: React.FC<Props> = ({ delegateId }) => {
    const delegateName = useUserDisplayName(delegateId);

    if (delegateName === undefined) {
        return (
            <span className="flex justify-center">
                <Spinner className="max-w-6" />
            </span>
        );
    }

    return <span>{delegateName}</span>;
};
